import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';
import Language from '../fw/defaults/language';
import AdsHelpers from '../ads/ads-helpers';


export default class AdsIma {

  #rmp;
  #adsLoader = null;
  #adDisplayContainer = null;
  #runAdsManagerInterval = null;
  #adErrorCode = -1;
  #adErrorMessage = '';
  #adErrorType = '';
  #adVastErrorCode = -1;
  #firstPreroll = true;
  #currentiOSSrc = '';
  #adVmapInput = false;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get adsLoader() {
    return this.#adsLoader;
  }

  get adDisplayContainer() {
    return this.#adDisplayContainer;
  }

  get adErrorCode() {
    return this.#adErrorCode;
  }

  get adErrorMessage() {
    return this.#adErrorMessage;
  }

  get adErrorType() {
    return this.#adErrorType;
  }

  get adVastErrorCode() {
    return this.#adVastErrorCode;
  }

  get adVmapInput() {
    return this.#adVmapInput;
  }

  #destroyAdsManager() {
    if (this.#rmp.imaAdsManager) {
      this.#rmp.imaAdsManager.destroy();
    }
  }

  #restoreContentUI() {
    Logger.print('google-ima', 'restore content UI');
    if (this.#rmp.isVod) {
      this.#rmp.rmpUtils.refreshHtml5VideoEndedManagement();
    }
    if (this.#rmp.readingPDorNative) {
      this.#rmp.rmpUtils.refreshHtml5VideoErrorManagement();
    }
    this.#rmp.rmpAdsHelpers.setUIForAds(false);
  }

  #resetImaAdError() {
    this.#adErrorCode = -1;
    this.#adErrorMessage = '';
    this.#adErrorType = '';
    this.#adVastErrorCode = -1;
  }

  #onContentResumeRequested() {
    this.#rmp.imaAdPaused = false;
    this.#rmp.imaAdOnStage = false;
    // restore content UI
    this.#restoreContentUI();
    if (this.#rmp.adOutStream) {
      this.#rmp.rmpAdsHelpers.endedOutStreamUI();
      this.#rmp.dispatch('adcontentresumerequested');
      return;
    }
    if (!this.#rmp.contentCompleteCalled) {
      if (this.#firstPreroll) {
        this.#firstPreroll = false;
        if (this.#rmp.offsetStartPosition > 0) {
          this.#rmp.rmpAdsHelpers.seekToOffsetStartPosition();
        }
      }
      if (Env.isIos[0] && !this.#rmp.adDisableCustomPlaybackForIOS10Plus && this.#adErrorCode === 200) {
        window.setTimeout(() => {
          this.#rmp.rmpUtils.playPromise();
        }, 1);
      } else {
        this.#rmp.rmpUtils.playPromise();
      }
    }
    this.#rmp.dispatch('adcontentresumerequested');
  }

  #waterfall() {
    if (Array.isArray(this.#rmp.adTagWaterfall) && typeof this.#rmp.adTagWaterfall[0] === 'string' && this.#rmp.adTagWaterfall[0] !== '') {
      this.#rmp.adTagUrl = this.#rmp.adTagWaterfall[0];
      if (this.#rmp.adTagWaterfall.length > 0) {
        this.#rmp.adTagWaterfall.shift();
      }
      this.#rmp.loadAds(this.#rmp.adTagUrl, ['internal']).catch(error => {
        this.#rmp.rmpUtils.warning(1020, error);
        this.#rmp.rmpUtils.playPromise();
      });
      this.#rmp.dispatch('adclientsidewaterfallrequested');
    } else {
      this.#destroyAdsManager();
      this.#onContentResumeRequested();
    }
    this.#resetImaAdError();
  }

  #onAdError(adErrorEvent) {
    const ignoreVastErrorCodes = [200, 201, 202, 203, 600, 601, 603, 604];
    const error = adErrorEvent.getError();
    if (typeof error !== 'undefined') {
      this.#adErrorCode = error.getErrorCode();
      this.#adErrorMessage = error.getMessage();
      this.#adErrorType = error.getType();
      this.#adVastErrorCode = error.getVastErrorCode();
      Logger.print('google-ima', 'getErrorCode - ' + this.#adErrorCode);
      Logger.print('google-ima', 'getMessage - ' + this.#adErrorMessage);
      Logger.print('google-ima', 'getType - ' + this.#adErrorType);
      Logger.print('google-ima', 'getVastErrorCode - ' + this.#adVastErrorCode);
      // 602 error > go to #waterfall
      if (ignoreVastErrorCodes.indexOf(this.#adVastErrorCode) > -1) {
        Logger.print('google-ima', 'VastErrorCode 200|201|202|203|600|601|603|604 - trying to play ad nonetheless');
        this.#rmp.dispatch('adlog');
        this.#resetImaAdError();
        return;
      }
    }
    this.#rmp.dispatch('aderror');
    this.#waterfall();
  }

  #handleImaAdPod(ad) {
    // adpod for VMAP
    this.#rmp.imaAdPodInfo = ad.getAdPodInfo();
    Logger.print('google-ima', 'Ad Pod detected');
    Logger.print('google-ima', 'getAdPosition ' + this.#rmp.imaAdPodInfo.getAdPosition());
    Logger.print('google-ima', 'getIsBumper ' + this.#rmp.imaAdPodInfo.getIsBumper());
    Logger.print('google-ima', 'getMaxDuration ' + this.#rmp.imaAdPodInfo.getMaxDuration());
    Logger.print('google-ima', 'getPodIndex ' + this.#rmp.imaAdPodInfo.getPodIndex());
    Logger.print('google-ima', 'getTimeOffset ' + this.#rmp.imaAdPodInfo.getTimeOffset());
    Logger.print('google-ima', 'getTotalAds ' + this.#rmp.imaAdPodInfo.getTotalAds());
    FW.setText(this.#rmp.dom.adPod, '');
    if (this.#rmp.imaAdPodInfo && this.#rmp.dom.adInfo) {
      const totalAds = this.#rmp.imaAdPodInfo.getTotalAds();
      if (typeof totalAds === 'number' && totalAds > 1) {
        if (!this.#rmp.dom.adPod) {
          this.#rmp.dom.adPod = FW.createElement('span', 'rmp-ad-info-pod');
          if (this.#rmp.dom.adCountdown) {
            FW.insertBefore(this.#rmp.dom.adInfo, this.#rmp.dom.adPod, this.#rmp.dom.adCountdown);
          } else {
            this.#rmp.dom.adInfo.appendChild(this.#rmp.dom.adPod);
          }
        }
        const adPosition = this.#rmp.imaAdPodInfo.getAdPosition();
        if (typeof adPosition === 'number') {
          FW.setText(this.#rmp.dom.adPod, adPosition + '/' + totalAds);
        }
      }
    }
  }

  #handleAdLog(adEvent) {
    const adData = adEvent.getAdData();
    if (typeof adData === 'object' && adData.adError) {
      const error = adData.adError;
      this.#adErrorCode = error.getErrorCode();
      this.#adErrorMessage = error.getMessage();
      this.#adErrorType = error.getType();
      this.#adVastErrorCode = error.getVastErrorCode();
      this.#rmp.dispatch('adlog');
      Logger.print('google-ima', 'getErrorCode - ' + this.#adErrorCode);
      Logger.print('google-ima', 'getMessage - ' + this.#adErrorMessage);
      Logger.print('google-ima', 'getType - ' + this.#adErrorType);
      Logger.print('google-ima', 'getVastErrorCode - ' + this.#adVastErrorCode);
      this.#resetImaAdError();
    }
  }

  #handleAdComplete() {
    if (!this.#rmp.isLive) {
      FW.setText(this.#rmp.dom.timeElapsedText, FW.readableTime(FW.getMediaCurrentTime(this.#rmp.dom.video)));
      const duration = this.#rmp.duration;
      if (duration > -1) {
        this.#rmp.rmpUtils.updateDurationText(duration, this.#rmp.currentTime);
      }
    }
    this.#rmp.dispatch('adcomplete');
  }

  #handleAllAdsCompleted() {
    // get correct duration for video when ad ends on iOS with adForceNativeFullscreenOnIosForAds
    if (Env.isIos[0] && this.#rmp.adForceNativeFullscreenOnIosForAds && this.#rmp.isVod) {
      this.#rmp.imaAdOnStage = false;
    }
    this.#rmp.dispatch('adalladscompleted');
    if (this.#rmp.contentCompleteCalled) {
      // we are in a post-roll scenario
      this.#rmp.contentCompleteCalled = false;
      if (!this.#rmp.loopConfiguration) {
        this.#rmp.rmpUIManagement.restorePlayUI();
      }
      if (Env.isIos[0] &&
        !this.#rmp.adDisableCustomPlaybackForIOS10Plus &&
        this.#rmp.dom.video.src !== this.#currentiOSSrc &&
        this.#rmp.usingNativeHlsOnAppleDevices) {
        this.#rmp.srcChangeAutoplay = false;
        const streamType = this.#rmp.streamType;
        this.#rmp.setSrc({ [streamType]: this.#currentiOSSrc }).catch(error => {
          this.#rmp.rmpUtils.warning(1025, error);
        });
      }
    }
  }

  #beforeLoadAndStart(ad, type) {
    // reset VPAID value in case mix linear/non-linear or VMAP
    this.#rmp.isVPAID = false;
    // update ad data on start and load
    const isLinear = ad.isLinear();
    if (typeof isLinear === 'boolean') {
      this.#rmp.imaAdLinear = isLinear;
      // muted on adloaded if isLinear to avoid small audio quircks that may 
      // happen on adstarted
      if (this.#rmp.imaAdLinear && type === 'adloaded') {
        if (this.#rmp.muted) {
          this.#rmp.rmpAdsHelpers.setAdMute(true);
        } else {
          this.#rmp.rmpAdsHelpers.setAdVolume(this.#rmp.volume);
        }
      }
    }
    if (type === 'adstarted') {
      this.#rmp.imaAdOnStage = true;
      // in case we are in FS before an ad starts
      this.#rmp.resize();
      this.#rmp.dom.adContainer.classList.remove('rmp-ad-overlay');
      this.#rmp.imaAdID = ad.getAdId();
      this.#rmp.imaAdSystem = ad.getAdSystem();
      this.#rmp.imaAdvertiserName = ad.getAdvertiserName();
      this.#rmp.imaAdApiFramework = ad.getApiFramework();
      this.#rmp.imaAdContentType = ad.getContentType();
      this.#rmp.imaAdCreativeAdId = ad.getCreativeAdId();
      this.#rmp.imaAdCreativeId = ad.getCreativeId();
      this.#rmp.imaAdDealId = ad.getDealId();
      this.#rmp.imaAdDescription = ad.getDescription();
      this.#rmp.imaAdDuration = ad.getDuration();
      // Returns the height of the selected non-linear creative.
      this.#rmp.imaAdNonLinearHeight = ad.getHeight();
      this.#rmp.imaAdMediaUrl = ad.getMediaUrl();
      this.#rmp.imaAdSkipTimeOffset = ad.getSkipTimeOffset();//+
      this.#rmp.imaAdSurveyUrl = ad.getSurveyUrl();
      this.#rmp.imaAdTitle = ad.getTitle();
      this.#rmp.imaAdTraffickingParameters = ad.getTraffickingParameters();
      this.#rmp.imaAdTraffickingParametersString = ad.getTraffickingParametersString();
      this.#rmp.imaAdUniversalAdIds = ad.getUniversalAdIds();//+
      this.#rmp.imaAdLinearHeight = ad.getVastMediaHeight();//+
      this.#rmp.imaAdLinearWidth = ad.getVastMediaWidth();//+
      this.#rmp.imaAdNonLinearWidth = ad.getWidth();
      this.#rmp.imaAdWrapperAdIds = ad.getWrapperAdIds();
      this.#rmp.imaAdWrapperAdSystems = ad.getWrapperAdSystems();
      this.#rmp.imaAdWrapperCreativeIds = ad.getWrapperCreativeIds();
      this.#rmp.currentAdForCompanion = ad;
    }
  }

  #handleAdLoaded(ad) {
    this.#beforeLoadAndStart(ad, 'adloaded');
    this.#rmp.dispatch('adloaded');
  }

  #handleAdStarted(ad) {
    this.#beforeLoadAndStart(ad, 'adstarted');
    if (this.#rmp.googleCastConnected || (this.#rmp.video360 && !this.#rmp.imaAdLinear)) {
      Logger.print('google-cast', 'casting is engaged or type is non-linear with 360 video - cancelling ad request');
      if (this.#rmp.video360) {
        FW.hide(this.#rmp.dom.adContainer);
      }
      this.#rmp.stopAds().catch(error => {
        this.#rmp.rmpUtils.warning(1021, error);
      });
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
      return;
    }
    this.#rmp.rmpAdsHelpers.updateVPAIDStatus(this.#rmp.imaAdLinear);
    if (this.#rmp.imaAdLinear) {
      this.#rmp.imaAdPaused = false;
      this.#rmp.rmpAdsHelpers.udpatePlayPause();
      // countdown
      if (this.#rmp.adCountDown && this.#rmp.dom.adInfo) {
        this.#rmp.rmpAdsHelpers.addCountDown();
      }
      // handle adPods
      this.#handleImaAdPod(ad);
      // hide poster 
      this.#rmp.hidePoster();
    } else {
      if (this.#rmp.adOutStream) {
        // non-linear ad not allowed for outstream > discard it
        // but #waterfall may exist as a fallback 
        this.#rmp.stopAds().catch(error => {
          this.#rmp.rmpUtils.warning(1021, error);
        });
        this.#waterfall();
      } else {
        // in case we are in VMAP and there is a final non-linear ad following a linear ad
        // we need to make sure content 
        this.#restoreContentUI();
        // only apply rmp-ad-overlay offset if non-linear ad does not take full height of player
        const playerSize = this.#rmp.getPlayerSize();
        if (this.#rmp.imaAdNonLinearHeight + 40 < playerSize.height) {
          this.#rmp.dom.adContainer.classList.add('rmp-ad-overlay');
        }
        if (!this.#rmp.adAutoAlign) {
          this.#rmp.dom.adContainer.classList.add('rmp-ad-no-auto-align');
        }
        // proper handling of offsetStartPosition for non-linear
        if (this.#rmp.offsetStartPosition > 0) {
          this.#rmp.rmpAdsHelpers.seekToOffsetStartPosition();
        }
        this.#rmp.rmpUtils.playPromise();
      }
    }
    this.#rmp.dispatch('adstarted');
  }

  #handleResumed() {
    this.#rmp.imaAdPaused = false;
    this.#rmp.rmpAdsHelpers.udpatePlayPause();
    this.#rmp.dispatch('adresumed');
  }

  #handlePaused() {
    this.#rmp.imaAdPaused = true;
    this.#rmp.rmpAdsHelpers.udpatePlayPause();
    this.#rmp.dispatch('adpaused');
  }

  #onAdEvent(adEvent) {
    if (typeof adEvent === 'object') {
      if (DEBUG) {
        if (this.#rmp.debugLevel === 2) {
          Logger.print('google-ima', adEvent.type);
        }
      }
      const ad = adEvent.getAd();
      if (typeof ad === 'object' && adEvent.type) {
        switch (adEvent.type) {
          case google.ima.AdEvent.Type.LOADED:
            this.#handleAdLoaded(ad);
            break;
          case google.ima.AdEvent.Type.STARTED:
            this.#handleAdStarted(ad);
            break;
          case google.ima.AdEvent.Type.COMPLETE:
            this.#handleAdComplete();
            break;
          case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
            this.#handleAllAdsCompleted();
            break;
          case google.ima.AdEvent.Type.RESUMED:
            this.#handleResumed();
            break;
          case google.ima.AdEvent.Type.PAUSED:
            this.#handlePaused();
            break;
          case google.ima.AdEvent.Type.CLICK:
            this.#rmp.dispatch('adclick');
            break;
          case google.ima.AdEvent.Type.AD_BREAK_READY:
            this.#rmp.dispatch('adbreakready');
            break;
          case google.ima.AdEvent.Type.AD_METADATA:
            this.#rmp.dispatch('admetadata');
            break;
          case google.ima.AdEvent.Type.DURATION_CHANGE:
            this.#rmp.dispatch('addurationchange');
            break;
          case google.ima.AdEvent.Type.FIRST_QUARTILE:
            this.#rmp.dispatch('adfirstquartile');
            break;
          case google.ima.AdEvent.Type.MIDPOINT:
            this.#rmp.dispatch('admidpoint');
            break;
          case google.ima.AdEvent.Type.THIRD_QUARTILE:
            this.#rmp.dispatch('adthirdquartile');
            break;
          case google.ima.AdEvent.Type.IMPRESSION:
            this.#rmp.dispatch('adimpression');
            break;
          case google.ima.AdEvent.Type.INTERACTION:
            this.#rmp.dispatch('adinteraction');
            break;
          case google.ima.AdEvent.Type.LINEAR_CHANGED:
            this.#rmp.dispatch('adlinearchanged');
            break;
          case google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED:
            this.#rmp.dispatch('adskippablestatechanged');
            break;
          case google.ima.AdEvent.Type.SKIPPED:
            this.#rmp.dispatch('adskipped');
            break;
          case google.ima.AdEvent.Type.USER_CLOSE:
            this.#rmp.dispatch('aduserclose');
            break;
          case google.ima.AdEvent.Type.VOLUME_CHANGED:
            this.#rmp.dispatch('advolumechanged');
            break;
          case google.ima.AdEvent.Type.VOLUME_MUTED:
            this.#rmp.dispatch('advolumemuted');
            break;
          case google.ima.AdEvent.Type.AD_PROGRESS:
            this.#rmp.dispatch('adprogress');
            break;
          case google.ima.AdEvent.Type.LOG:
            this.#handleAdLog(adEvent);
            break;
          default:
            break;
        }
      }
    }
  }

  #onContentPauseRequested() {
    if (Env.isIos[0] &&
      !this.#rmp.adDisableCustomPlaybackForIOS10Plus &&
      this.#rmp.dom.video.src &&
      this.#rmp.usingNativeHlsOnAppleDevices) {
      this.#currentiOSSrc = this.#rmp.dom.video.src;
    }
    // upper liner
    if (this.#rmp.adShowRemainingTime) {
      this.#rmp.rmpAdsHelpers.appendRemainingTimeBar();
    }
    if (this.#rmp.isVod) {
      this.#rmp.dom.video.removeEventListener('ended', this.#rmp.endedFn);
    }
    if (this.#rmp.readingPDorNative) {
      this.#rmp.dom.video.removeEventListener('error', this.#rmp.generateErrorFn, true);
    }
    this.#rmp.rmpAdsHelpers.setUIForAds(true);
    if (!this.#rmp.adOutStream && !this.#rmp.dom.video.paused) {
      this.#rmp.dom.video.pause();
    }
    this.#rmp.dispatch('adcontentpauserequested');
  }

  #runProcessAdsManager(adsManagerLoadedEvent) {
    Logger.print('google-ima', '#runProcessAdsManager');
    const adsRenderingSettings = new google.ima.AdsRenderingSettings();
    adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
    // https://developers.google.com/interactive-media-ads/docs/sdks/html5/preload#limitations
    let validPreloadDevices = true;
    if (Env.isIos[0] || Env.smartTVData.tv) {
      validPreloadDevices = false;
    }
    if (this.#rmp.adEnablePreloading && validPreloadDevices) {
      adsRenderingSettings.enablePreloading = true;
      Logger.print('google-ima', 'enablePreloading set to true for Google IMA');
    } else {
      adsRenderingSettings.enablePreloading = false;
    }
    if (this.#rmp.adLoadMediaTimeout > 0) {
      adsRenderingSettings.loadVideoTimeout = this.#rmp.adLoadMediaTimeout;
    }
    if (!this.#rmp.adAutoAlign) {
      adsRenderingSettings.autoAlign = this.#rmp.adAutoAlign;
    }
    if (Env.isIpadOS) {
      adsRenderingSettings.useStyledLinearAds = true;
    }
    const bwEstimate = Env.getEstimateBW();
    if (bwEstimate > -1) {
      adsRenderingSettings.bitrate = Math.round(bwEstimate / 1000);
    }
    if (this.#rmp.adUseStyledNonLinearAds) {
      adsRenderingSettings.useStyledNonLinearAds = true;
    }
    if (this.#rmp.isMobile && this.#rmp.dom.container.classList.contains('rmp-outstream')) {
      adsRenderingSettings.uiElements = [];
    }
    this.#rmp.imaAdsManager = adsManagerLoadedEvent.getAdsManager(this.#rmp.dom.video, adsRenderingSettings);
    this.#rmp.dispatch('adadsmanagerloaded');
    const events = [
      google.ima.AdEvent.Type.AD_METADATA,
      google.ima.AdEvent.Type.LOG,
      google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
      google.ima.AdEvent.Type.CLICK,
      google.ima.AdEvent.Type.COMPLETE,
      google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
      google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
      google.ima.AdEvent.Type.DURATION_CHANGE,
      google.ima.AdEvent.Type.FIRST_QUARTILE,
      google.ima.AdEvent.Type.IMPRESSION,
      google.ima.AdEvent.Type.INTERACTION,
      google.ima.AdEvent.Type.LINEAR_CHANGED,
      google.ima.AdEvent.Type.LOADED,
      google.ima.AdEvent.Type.MIDPOINT,
      google.ima.AdEvent.Type.PAUSED,
      google.ima.AdEvent.Type.RESUMED,
      google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED,
      google.ima.AdEvent.Type.SKIPPED,
      google.ima.AdEvent.Type.STARTED,
      google.ima.AdEvent.Type.THIRD_QUARTILE,
      google.ima.AdEvent.Type.USER_CLOSE,
      google.ima.AdEvent.Type.VOLUME_CHANGED,
      google.ima.AdEvent.Type.VOLUME_MUTED
    ];
    events.forEach(event => {
      this.#rmp.imaAdsManager.addEventListener(event, this.#onAdEvent.bind(this));
    });
    this.#rmp.imaAdsManager.addEventListener(
      google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
      this.#onContentPauseRequested.bind(this));
    this.#rmp.imaAdsManager.addEventListener(
      google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
      this.#onContentResumeRequested.bind(this));
    // Handle errors.
    this.#rmp.imaAdsManager.addEventListener(
      google.ima.AdErrorEvent.Type.AD_ERROR,
      this.#onAdError.bind(this));
    // handle VMAP cue points
    let arrayCuePoints = this.#rmp.imaAdsManager.getCuePoints();
    if (Array.isArray(arrayCuePoints) && arrayCuePoints.length > 0) {
      Logger.print('google-ima', 'VMAP ad schedule detected', arrayCuePoints);
      if (this.#rmp.adShowMarkers && this.#rmp.isVod) {
        let arrayMarkers = [];
        arrayCuePoints.forEach(cuePoint => {
          if (cuePoint === -1) {
            arrayMarkers.push(Infinity);
          } else {
            arrayMarkers.push(cuePoint);
          }
        });
        Logger.print('google-ima', 'VMAP markers follow', arrayMarkers);
        let duration = this.#rmp.duration;
        if (this.#rmp.isVod && duration > -1) {
          duration = duration / 1000;
          this.#adVmapInput = true;
          this.#rmp.rmpAdsHelpers.createAdMarkers(arrayMarkers, duration);
        }
      }
    }
    const playerSize = this.#rmp.getPlayerSize();
    try {
      this.#rmp.imaAdsManager.init(playerSize.width, playerSize.height);
      this.#rmp.imaAdsManager.start();
    } catch (warning) {
      console.warn(warning);
      // An error may be thrown if there was a problem with the VAST response.
      this.#rmp.play().catch(warning2 => {
        console.warn(warning2);
      });
    }
  }

  #onAdsManagerLoaded(adsManagerLoadedEvent) {
    Logger.print('google-ima', '#onAdsManagerLoaded');
    if (this.#rmp.hasLoadedMetadata) {
      this.#runProcessAdsManager(adsManagerLoadedEvent);
    } else {
      window.clearInterval(this.#runAdsManagerInterval);
      this.#runAdsManagerInterval = window.setInterval(() => {
        if (this.#rmp.hasLoadedMetadata) {
          window.clearInterval(this.#runAdsManagerInterval);
          this.#runProcessAdsManager(adsManagerLoadedEvent);
        }
      }, 40);
    }
  }

  #onImaAvailable() {
    Logger.print('google-ima',
      'Google HTML5 client-side IMA SDK available at ' + (FW.getNow() - this.#rmp.refTime) + ' ms');
    if (typeof google !== 'undefined' && typeof google.ima !== 'undefined') {
      this.#rmp.adParserLoaded = true;
      if (this.#rmp.dom.adContainer && this.#rmp.dom.video) {
        if (this.#rmp.adLocale === 'auto') {
          this.#rmp.adLocale = Language.codes[this.#rmp.rmpInitManagement.validatedLanguage][0];
        }
        google.ima.settings.setLocale(this.#rmp.adLocale);
        google.ima.settings.setNumRedirects(this.#rmp.adMaxNumRedirects);
        google.ima.settings.setCookiesEnabled(this.#rmp.adCookiesEnabled);
        if (this.#rmp.adCompanionBackfillMode === 'onmasterad') {
          google.ima.settings.setCompanionBackfill(google.ima.ImaSdkSettings.CompanionBackfillMode.ON_MASTER_AD);
        }
        if (this.#rmp.adPpid !== '') {
          google.ima.settings.setPpid(this.#rmp.adPpid);
        }
        if (this.#rmp.adSessionId !== '') {
          google.ima.settings.setSessionId(this.#rmp.adSessionId);
        }
        if (this.#rmp.adVpaidMode === 'enabled') {
          google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED);
        } else if (this.#rmp.adVpaidMode === 'insecure') {
          google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.INSECURE);
        } else {
          google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.DISABLED);
        }
        if (Env.isIos[0] && Env.isIos[1] >= 10) {
          google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.#rmp.adDisableCustomPlaybackForIOS10Plus);
        }
        google.ima.settings.setPlayerType('radiantmediaplayer');
        google.ima.settings.setPlayerVersion(this.#rmp.playerVersion);
        Logger.print('google-ima', 'featureFlags follow', google.ima.settings.getFeatureFlags());
        try {
          this.#adDisplayContainer = new google.ima.AdDisplayContainer(this.#rmp.dom.adContainer, this.#rmp.dom.video);
          this.#adsLoader = new google.ima.AdsLoader(this.#adDisplayContainer);
          this.#adsLoader.addEventListener(
            google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
            this.#onAdsManagerLoaded.bind(this)
          );
          this.#adsLoader.addEventListener(
            google.ima.AdErrorEvent.Type.AD_ERROR,
            this.#onAdError.bind(this)
          );
        } catch (warning) {
          console.warn(warning);
          this.#rmp.rmpReadyManagement.fire();
          return;
        }
        this.#rmp.rmpAdsHelpers.createControlBarAdInfo();
      }

    }
    this.#rmp.rmpReadyManagement.fire();
  }

  #imaLoadError() {
    this.#rmp.rmpUtils.warning(10001);
    this.#rmp.adParserLoadError = true;
    this.#rmp.ads = false;
    this.#rmp.rmpReadyManagement.fire();
    this.#rmp.dispatch('adblock');
    // this needs to go after ready so that API is available
    if (this.#rmp.adOutStream) {
      this.#rmp.rmpAdsHelpers.endedOutStreamUI();
    }
  }

  destroy() {
    window.clearInterval(this.#runAdsManagerInterval);
    this.#rmp.rmpAdsHelpers.clearAdRemainingTimeBarInterval();
    try {
      this.#adsLoader.destroy();
      this.#adDisplayContainer.destroy();
    } catch (warning) {
      console.warn(warning);
    }
  }

  resetAdsForNewRequest() {
    Logger.print('google-ima', 'reset for new ad request');
    this.#rmp.rmpAdsHelpers.clearAdRemainingTimeBarInterval();
    this.#rmp.imaAdOnStage = false;
    this.#rmp.imaAdPaused = false;
    this.#rmp.isVPAID = false;
    // if loading ads before current has ended we need to restore content UI
    // this is to make sure correct UI is displayed if next ad is non-linear
    if (this.#rmp.linearAdOnStage) {
      this.#restoreContentUI();
    }
    this.#destroyAdsManager();
  }

  requestImaAds(adTag) {
    Logger.print('google-ima', 'request ad at URI - ' + adTag);
    if (this.#rmp.adParserLoaded && this.#adsLoader) {
      // do not show spinner when loadAds is called after content has started
      const currentTime = this.#rmp.currentTime;
      if (currentTime === 0) {
        this.#rmp.rmpUIManagement.showLoadingSpin();
      }
      this.#rmp.on('adstarted aderror', () => {
        this.#rmp.rmpUIManagement.hideLoadingSpin();
      });

      let adsRequest;
      try {
        adsRequest = new google.ima.AdsRequest();
      } catch (warning) {
        console.warn(warning);
        this.#rmp.play().catch(warning2 => {
          console.warn(warning2);
        });
        return;
      }
      const vastXmlPattern = /^<\?xml.+\?>/i;
      if (vastXmlPattern.test(adTag)) {
        adsRequest.adsResponse = adTag;
      } else {
        adsRequest.adTagUrl = adTag;
      }
      if (this.#rmp.adPageUrl) {
        adsRequest.pageUrl = this.#rmp.adPageUrl;
      }

      const playerSize = this.#rmp.getPlayerSize();
      adsRequest.linearAdSlotWidth = playerSize.width;
      adsRequest.linearAdSlotHeight = playerSize.height;

      let nonLinearAdSlotWidth = playerSize.width;
      if (this.#rmp.adNonLinearAdSlotWidth >= 0) {
        nonLinearAdSlotWidth = this.#rmp.adNonLinearAdSlotWidth;
      }
      adsRequest.nonLinearAdSlotWidth = nonLinearAdSlotWidth;

      let nonLinearAdSlotHeight = playerSize.height;
      if (this.#rmp.adNonLinearAdSlotHeight >= 0) {
        nonLinearAdSlotHeight = this.#rmp.adNonLinearAdSlotHeight;
      }
      adsRequest.nonLinearAdSlotHeight = nonLinearAdSlotHeight;

      adsRequest.vastLoadTimeout = this.#rmp.adLoadVastTimeout;
      if (this.#rmp.adForceNonLinearFullSlot) {
        adsRequest.forceNonLinearFullSlot = true;
      }
      const contentDuration = this.#rmp.duration;
      if (this.#rmp.adContentDuration > 0) {
        adsRequest.contentDuration = this.#rmp.adContentDuration;
      } else if (this.#rmp.isVod && contentDuration > -1) {
        adsRequest.contentDuration = contentDuration / 1000;
      }
      if (this.#rmp.adContentKeywords !== '') {
        adsRequest.contentKeywords = this.#rmp.adContentKeywords;
      }
      if (this.#rmp.adContentTitle !== '') {
        adsRequest.contentTitle = this.#rmp.adContentTitle;
      }
      if (this.#rmp.adLiveStreamPrefetchSeconds > 0) {
        adsRequest.liveStreamPrefetchSeconds = this.#rmp.adLiveStreamPrefetchSeconds;
      }
      adsRequest.setAdWillAutoPlay(this.#rmp.autoplay);
      adsRequest.setAdWillPlayMuted(this.#rmp.muted);
      if (!FW.isEmptyObject(this.#rmp.omidAccessModeRules)) {
        adsRequest.omidAccessModeRules = AdsHelpers.getOmidAccessModeRules(this.#rmp.omidAccessModeRules);
      }
      if (this.#rmp.adContinuousPlayback === 'auto') {
        if ((this.#rmp.hasPlaylist && this.#rmp.playlistUpNextAutoplay) ||
          (this.#rmp.hasRelated && this.#rmp.relatedUpNextAutoplay)) {
          adsRequest.setContinuousPlayback(true);
        } else {
          adsRequest.setContinuousPlayback(false);
        }
      } else if (this.#rmp.adContinuousPlayback === 'yes') {
        adsRequest.setContinuousPlayback(true);
      } else {
        adsRequest.setContinuousPlayback(false);
      }
      Logger.print('google-ima', 'adsRequest data follows', adsRequest);
      try {
        this.#adsLoader.requestAds(adsRequest);
      } catch (warning) {
        console.warn(warning);
        this.#rmp.play().catch(warning2 => {
          this.#rmp.rmpUtils.warning(1014, warning2);
        });
      }
    } else {
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
    }
  }

  init() {
    if (typeof google !== 'undefined' && typeof google.ima !== 'undefined') {
      this.#onImaAvailable();
    } else {
      let callScript;
      if (this.#rmp.adImaTest) {
        callScript = 'https://imasdk.googleapis.com/js/sdkloader/ima3_test.js';
      } else {
        callScript = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
      }
      if (DEBUG) {
        if (this.#rmp.debugLevel === 2) {
          callScript = 'https://imasdk.googleapis.com/js/sdkloader/ima3_debug.js';
        }
      }
      Logger.print('google-ima',
        'starts loading IMA SDK from Google servers at ' + (FW.getNow() - this.#rmp.refTime) + ' ms');
      FW.getScript(
        callScript,
        this.#onImaAvailable.bind(this),
        this.#imaLoadError.bind(this),
        this.#rmp.shadowRoot
      );
    }
  }

  resumeImaAds() {
    if (this.#rmp.imaAdsManager) {
      this.#rmp.imaAdsManager.resume();
    }
  }

  pauseImaAds() {
    if (this.#rmp.imaAdsManager) {
      this.#rmp.imaAdsManager.pause();
    }
  }
}
